import React, { useEffect } from "react";
import "./notification-channel-tab.css";

  const NotificationChannelTabs = ({
    activeChannel,
    hasUnsavedChanges,
    onChannelChange,
    accessibleChannels = [],   // [{id, label, isAccessible}]
  }) => {

    useEffect(() => {
      const firstAccessible = accessibleChannels.find((c) => c.isAccessible);
      if (firstAccessible && !activeChannel) {
        onChannelChange(firstAccessible.id);
      }
    }, [accessibleChannels, activeChannel, onChannelChange]);

    const handleClick = (channelId) => {
      const channel = accessibleChannels.find((c) => c.id === channelId);
      const isAccessible = channel ? channel.isAccessible : true;
      if (!isAccessible) return;

      if (hasUnsavedChanges && channelId !== activeChannel) {
        onChannelChange(null, channelId); // keep your warning pattern if needed
      } else {
        onChannelChange(channelId);       // this ends up calling setActiveCommModeId
      }
    };

    return (
      <div className="tab-channel-container">
        <div className="tab-channel-buttons">
          {accessibleChannels.map((ch) => {
            const isActive = ch.id === activeChannel;
            return (
              <button
                key={ch.id}
                type="button"
                className={`tab-channel-button ${isActive ? "active" : ""} ${
                  !ch.isAccessible ? "disabled" : ""
                }`}
                disabled={!ch.isAccessible}
                onClick={() => handleClick(ch.id)}
              >
                {ch.label.toUpperCase()}
              </button>
            );
          })}
        </div>
      </div>
    );
  };


export default NotificationChannelTabs;

















